import { CALL_API } from '../store/api';

export const CHECKEMAIL_REQUEST = "CHECKEMAIL_REQUEST";
export const CHECKEMAIL_SUCCESS = "CHECKEMAIL_SUCCESS";
export const CHECKEMAIL_FAILURE = "CHECKEMAIL_FAILURE";

export const FINDAGENT_REQUEST = "FINDAGENT_REQUEST";
export const FINDAGENT_SUCCESS = "FINDAGENT_SUCCESS";
export const FINDAGENT_FAILURE = "FINDAGENT_FAILURE";

export const CREATELEAD_REQUEST = "CREATELEAD_REQUEST";
export const CREATELEAD_SUCCESS = "CREATELEAD_SUCCESS";
export const CREATELEAD_FAILURE = "CREATELEAD_FAILURE";

export const SENDMAGICEMAIL_REQUEST = "SENDMAGICEMAIL_REQUEST"
export const SENDMAGICEMAIL_SUCCESS = "SENDMAGICEMAIL_SUCCESS"
export const SENDMAGICEMAIL_FAILURE = "SENDMAGICEMAIL_FAILURE"



export const checkEmail = (query) => (dispatch, getState) => {
  const { email } = query
  return dispatch({
    [CALL_API]: {
        types: [CHECKEMAIL_REQUEST, CHECKEMAIL_SUCCESS, CHECKEMAIL_FAILURE],
        method: 'GET',
        endpoint: `public/user/checkemail?userEmail=${email}`,
    },
    query: email
  }
)}

export const findAgent = (query) => (dispatch, getState) => {
  const { agentEmail } = query
  return dispatch({
    [CALL_API]: {
        types: [FINDAGENT_REQUEST, FINDAGENT_SUCCESS, FINDAGENT_FAILURE],
        method: 'GET',
        endpoint: `public/agent/find?agentEmail=${agentEmail}`,
    },
    query: agentEmail
  }
)}

export const useListingAgent = (listingAgent) => (dispatch, getState) => {
  return dispatch({
    type: 'FINDAGENT_SUCCESS',
    response: { agent: listingAgent }
  })
}

export const sendMagicEmail = (email) => (dispatch, getState) => {
  return dispatch({
    [CALL_API]: {
        types: [SENDMAGICEMAIL_REQUEST, SENDMAGICEMAIL_SUCCESS, SENDMAGICEMAIL_FAILURE],
        method: 'GET',
        endpoint: `public/user/magic-link?userEmail=${email}`,
    },
    query: email
  }
)}


export const createLead = (body) => (dispatch, getState) => {
  return dispatch({
    [CALL_API]: {
      types: [CREATELEAD_REQUEST, CREATELEAD_SUCCESS, CREATELEAD_FAILURE],
      method: 'POST',
        body: body,
        endpoint: `public/lead`,
    },
  })
}